import addCookieWithConsent from '../pattern_utilities/addCookieWithConsent';

export const toggleLights = data => dispatch => {
  addCookieWithConsent('lights', data, dispatch);
  dispatch(toggleLightsToReducer(data));
}

export const setGridMode = data => dispatch => {
  addCookieWithConsent('gridMode', JSON.stringify(data), dispatch);
  dispatch(setGridModeToReducer(data));
}

export const setAutoSave = data => dispatch => {
  addCookieWithConsent('autoSave', data, dispatch);
  dispatch(setAutoSavetoReducer(data));
}

export const setRecentPatterns = data => dispatch => {
  addCookieWithConsent('showRecentPatterns', JSON.stringify(data), dispatch);
  dispatch(setRecentPatternsToReducer(data));
}

////////////////////////////////////////////////
////////////////////////////////////////////////

export const toggleLightsToReducer = data => ({
  type: 'TOGGLE_LIGHTS',
  data
})

export const setGridModeToReducer = data => ({
  type: 'SET_GRID_MODE',
  data
})


export const showLockedFeatureModal = data => ({
  type: 'SHOW_LOCKED_FEATURE_MODAL',
  data
})


export const hideLockedFeatureModal = data => ({
  type: 'HIDE_LOCKED_FEATURE_MODAL',
  data
})


export const setDisplayZoomControls = data => ({
  type: 'SET_DISPLAY_ZOOM_CONTROLS',
  data
})

export const setDisplayGridLines = data => ({
  type: 'SET_DISPLAY_GRID_LINES',
  data
})

export const setDisplayColors = data => ({
  type: 'SET_DISPLAY_COLORS',
  data
})

export const setDisplayRulers = data => ({
  type: 'SET_DISPLAY_RULERS',
  data
})

export const setDisplayErrors = data => ({
  type: 'SET_DISPLAY_ERRORS',
  data
})

export const setAutoSavetoReducer = data => ({
  type: 'SET_AUTO_SAVE',
  data
})

export const setRecentPatternsToReducer = data => ({
  type: 'SET_RECENT_PATTERNS',
  data
})

export const setTrayOpen = data => ({
  type: 'SET_TRAY_OPEN',
  data
})


export const setDXFGeneratorOpen = data => ({
  type: 'SET_DXF_GENERATOR_OPEN',
  data
})

export const setLoginModalOpen = data => ({
  type: 'SET_LOGIN_MODAL_OPEN',
  data
})


export const setDownloadModalOpen = data => ({
  type: 'SET_DOWNLOAD_MODAL_OPEN',
  data
})


export const setTemplateModalOpen = data => ({
  type: 'SET_TEMPLATE_MODAL_OPEN',
  data
})

export const setScaleModalOpen = data => ({
  type: 'SET_SCALE_MODAL_OPEN',
  data
})

export const setRotateModalOpen = data => ({
  type: 'SET_ROTATE_MODAL_OPEN',
  data
})

export const setImageExportModalOpen = data => ({
  type: 'SET_IMAGE_EXPORT_MODAL_OPEN',
  data
})


export const setJDISettingsModalOpen = data => ({
  type: 'SET_JDI_SETTINGS_MODAL_OPEN',
  data
})

export const setFullScreen = data => ({
  type: 'SET_FULL_SCREEN',
  data
})


export const setMobilePreview = data => ({
  type: 'SET_MOBILE_PREVIEW',
  data
})


export const setQuadView = data => ({
  type: 'SET_QUAD_VIEW',
  data
})


////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// GENERIC LOG
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestLog = packet => {
  return {
    type: 'REQUEST_LOG',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveLogSuccess = data => ({
  type: 'RECEIVE_LOG_SUCCESS',
  data
})

export const receiveLogFail = data => ({
  type: 'RECEIVE_LOG_FAIL',
  data
})

export const tryToLog = packet => dispatch => {
  dispatch(requestLog(packet));
  
  return fetch('/api/log', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveLogSuccess(json));
    })
    .catch(e => {
      dispatch(receiveLogFail({errors:e}));
    })
}


// WEBPACK FOOTER //
// ./src/actions/actions.globalReducer.js